<template>
  <div class="stu-info-root">
    <template v-if="showData">
      <div class="info-wrap">
        <h3 class="title">个人信息<span v-if="['super','system','viewer'].includes(userType)" style="color:#f88594">（{{info.studentSingnInfo.total_score || '--'}}分）</span></h3>
        <div class="person-wrap fo-wrap info-cont-wrap">
          <div class="img-list">
            <div class="img-box ident">
              <img
                class="img"
                :src="
                  idImg1Err
                    ? identify1
                    : info.studentSingnInfo.id_card_photo_front
                "
                @error="idImg1Err = true"
              />
            </div>
            <div class="img-box ident">
              <img
                class="img"
                :src="
                  idImg2Err
                    ? identify2
                    : info.studentSingnInfo.id_card_photo_verso
                "
                @error="idImg2Err = true"
              />
            </div>
            <div class="passport img-box">
              <img
                class="img"
                :src="
                  avatorErr ? avatorImg : info.studentSingnInfo.profile_picture
                "
                @error="avatorErr = true"
              />
            </div>
          </div>
          <div class="fo-list">
            <div class="fo-item w_half">
              <div class="i_info clearfix">
                <span class="label">姓名:</span>
                <span class="text texthide">{{
                  info.studentSingnInfo.name | tranNull
                }}  <span v-if="!isFive && info.studentSingnInfo.is_high_player" style="color:#f88594;font-weight:bold" title="高水平职业球员认证">(G)</span></span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info clearfix">
                <span class="label">手机:</span>
                <span class="text texthide">{{
                  info.studentSingnInfo.mobile_phone | tranNull
                }}</span>
              </div>
            </div>
            <template
              v-if="
                info.studentSingnInfo.family_name_spell &&
                info.studentSingnInfo.given_name_spell === ''
              "
            >
              <div class="fo-item w_half">
                <div class="i_info clearfix">
                  <span class="label">姓名(拼音):</span>
                  <span class="text texthide">{{
                    info.studentSingnInfo.family_name_spell | tranNull
                  }}</span>
                </div>
              </div>
              <div class="fo-item w_half">
                <div class="i_info clearfix"></div>
              </div>
            </template>
            <template v-else>
              <div class="fo-item w_half">
                <div class="i_info clearfix">
                  <span class="label">姓氏(拼音):</span>
                  <span class="text texthide">{{
                    info.studentSingnInfo.family_name_spell | tranNull
                  }}</span>
                </div>
              </div>
              <div class="fo-item w_half">
                <div class="i_info clearfix">
                  <span class="label">名(拼音):</span>
                  <span class="text texthide">{{
                    info.studentSingnInfo.given_name_spell | tranNull
                  }}</span>
                </div>
              </div>
            </template>
            <div class="fo-item w_half">
              <div class="i_info clearfix">
                <span class="label">曾用名:</span>
                <span class="text texthide">{{
                  info.studentSingnInfo.former_name | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info clearfix">
                <span class="label">民族:</span>
                <span class="text texthide">{{
                  info.studentSingnInfo.nation | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info clearfix">
                <span class="label">国籍:</span>
                <span class="text texthide">{{
                  info.studentSingnInfo.nationality | tranCountry
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info clearfix">
                <span class="label">护照号:</span>
                <span class="text texthide">{{
                  info.studentSingnInfo.passport | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info clearfix">
                <span class="label">性别:</span>
                <span class="text texthide">{{
                  info.studentSingnInfo.gender === "Male" ? "男" : "女"
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info clearfix">
                <span class="label">出生日期:</span>
                <span class="text texthide">{{
                  info.studentSingnInfo.birthday | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info clearfix">
                <span class="label">身高:</span>
                <span class="text texthide"
                  >{{ info.studentSingnInfo.height | tranNull }}cm</span
                >
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info clearfix">
                <span class="label">体重:</span>
                <span class="text texthide"
                  >{{ info.studentSingnInfo.weight | tranNull }}kg</span
                >
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info clearfix">
                <span class="label">证件类型:</span>
                <span class="text texthide">{{
                  info.studentSingnInfo.id_type | getNumberType
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info clearfix">
                <span class="label">证件号:</span>
                <span class="text texthide">{{
                  info.studentSingnInfo.id_number | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info clearfix">
                <span class="label">电子邮箱:</span>
                <span class="text texthide">{{
                  info.studentSingnInfo.email_address | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info clearfix">
                <span class="label">固定电话:</span>
                <span class="text texthide">{{
                  info.studentSingnInfo.contact_numbers | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info clearfix">
                <span class="label">邮编(家):</span>
                <span class="text texthide">{{
                  info.studentSingnInfo.postcode | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info clearfix">
                <span class="label">传真(家):</span>
                <span class="text texthide">{{
                  info.studentSingnInfo.fax_personage | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_all">
              <div class="i_info clearfix">
                <span class="label">通讯地址:</span>
                <span class="text">{{
                  info.studentSingnInfo.contact_address | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_all">
              <div class="i_info clearfix">
                <span class="label">伤病历史:</span>
                <span class="text">{{
                  info.studentSingnInfo.medical_history | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_all">
              <div class="i_info clearfix">
                <span class="label">注册协会:</span>
                <span class="text">{{
                  info.studentSingnInfo.org_abbreviation | tranNull
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="info-wrap">
        <h3 class="title">单位信息</h3>
        <div class="unit-wrap fo-wrap info-cont-wrap">
          <div class="fo-list">
            <div class="fo-item w_all">
              <div class="i_info clearfix">
                <span class="label">单位名称:</span>
                <span class="text">{{info.studentSingnInfo.club_name | tranNull}}</span>
              </div>
            </div>
            <div class="fo-item w_all">
              <div class="i_info clearfix">
                <span class="label">单位地址:</span>
                <span class="text">{{info.studentSingnInfo.club_address | tranNull}}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info clearfix">
                <span class="label">单位邮编:</span>
                <span class="text texthide">{{info.studentSingnInfo.club_postcode | tranNull}}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info clearfix">
                <span class="label">电话:</span>
                <span class="text texthide">{{info.studentSingnInfo.club_telephone | tranNull}}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info clearfix">
                <span class="label">传真:</span>
                <span class="text texthide">{{info.studentSingnInfo.club_fax | tranNull}}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info clearfix">
                <span class="label">网址:</span>
                <span class="text texthide">{{info.studentSingnInfo.club_website | tranNull}}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info clearfix">
                <span class="label">电子邮箱:</span>
                <span class="text texthide">{{info.studentSingnInfo.club_email | tranNull}}</span>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="info-wrap" v-if="!isFive && info.studentSingnInfo.is_high_player">
        <h3 class="title">高水平职业球员认证</h3>
        <div class="wear-wrap fo-wrap info-cont-wrap">
          <div class="fo-list">
            <div class="fo-item">
              <div class="i_info">
                <span class="text texthide t_pre">{{info.studentSingnInfo.authentication_type | AuthenticationType}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="info-wrap">
        <h3 class="title">现执教情况</h3>
        <div class="wear-wrap fo-wrap info-cont-wrap">
          <div class="fo-list">
            <div class="fo-item">
              <div class="i_info">
                <span>执教单位：{{info.studentSingnInfo.take_unit || '--'}}</span>
                <span  v-if="info.studentSingnInfo.team_age"> / {{info.studentSingnInfo.team_age}}</span>
                <span  v-if="info.studentSingnInfo.team_sex"> / {{info.studentSingnInfo.team_sex}}</span>
                <span  v-if="info.studentSingnInfo.take_job"> / {{info.studentSingnInfo.take_job}}</span>
                <p>
                  <span>单位名称：{{info.studentSingnInfo.take_unit_name || '--'}}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="info-wrap">
        <h3 class="title">执教经历</h3>
        <div class="wear-wrap fo-wrap info-cont-wrap">
          <div class="fo-list">
            <div class="fo-item">
              <div class="i_info">
                <span class="text texthide t_pre">{{
                  info.studentSingnInfo.coach_experience | experienceFilter
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="info-wrap">
        <h3 class="title">运动经历</h3>
        <div class="wear-wrap fo-wrap info-cont-wrap">
          <div class="fo-list">
            <div class="fo-item">
              <div class="i_info">
                <span class="text texthide t_pre">{{info.studentSingnInfo.sport_experience_new || '--'}}</span><span v-if="info.studentSingnInfo.is_goalkeeper">{{info.studentSingnInfo.is_goalkeeper === '是' ? '（守门员）' : '（非守门员）'}}</span>
              </div>
              <div class="i_info" v-if="['国家一线队','顶级职业联赛（中超/女超/海外顶级联赛）','第二级别联赛（中甲/女甲/海外次级别联赛）','第三级别联赛（中乙/女乙/海外第三级别联赛）','五人制职业联赛（五超/女五）','五人制第二级别联赛（五甲）'].includes(info.studentSingnInfo.sport_experience_new) && info.studentSingnInfo.highest_experience_record">
                <span class="text texthide t_pre">最高级别正式比赛出场次数：{{info.studentSingnInfo.highest_experience_record || '--'}} 场</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="info-wrap">
        <h3 class="title">装备尺码</h3>
        <div class="wear-wrap fo-wrap info-cont-wrap">
          <div class="fo-list">
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label">套服:</span>
                <span class="text texthide">{{
                  info.studentSingnInfo.track_suit | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label">T恤:</span>
                <span class="text texthide">{{
                  info.studentSingnInfo.polo_T | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label">短裤:</span>
                <span class="text texthide">{{
                  info.studentSingnInfo.shorts | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label">跑步鞋号:</span>
                <span class="text texthide">{{
                  info.studentSingnInfo.track_shoes | tranNull
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="info-wrap" v-if="info.studentSingnInfo.english_ability || info.language_list.length > 0">
        <h3 class="title">外语</h3>
        <div class="lan-wrap fo-wrap info-cont-wrap" v-if="info.studentSingnInfo.english_ability">
          <div class="fo-list" style="border-bottom: 1px dashed #ccc;margin-bottom:15px">
            <div class="fo-item" style="width: 100%;">
              <div class="i_info" style="display:flex">
                <span class="label" style="width:150px">英语能力:</span>
                <span >{{info.studentSingnInfo.english_ability | EnglishAbilityFilter}}</span>
              </div>
              <div class="i_info" style="display:flex">
                <span class="label" style="width:150px" v-if="['basic','good'].includes(info.studentSingnInfo.english_ability)">成绩报告单编号:</span>
                <span v-if="['basic','good'].includes(info.studentSingnInfo.english_ability)">{{info.studentSingnInfo.english_ability_number || '--'}}</span>
                <span class="label" style="width:150px" v-if="info.studentSingnInfo.english_file">英语能力证明文件:</span>
                <a class="suc" :href="info.studentSingnInfo.english_file" target="_blank" v-if="info.studentSingnInfo.english_file">点击查看</a>
              </div>
            </div>
          </div>
        </div>
        <div class="lan-wrap fo-wrap info-cont-wrap" v-show="info.language_list.length > 0">
          <div
            class="fo-list"
            v-for="(item, index) in info.language_list"
            :key="index"
          >
            <div class="fo-item w_one_third">
              <div class="i_info">
                <span class="label">其他语种:</span>
                <span class="text texthide">{{
                  item.language_ids | tranLang
                }}</span>
              </div>
            </div>
            <div class="fo-item w_one_third">
              <div class="i_info">
                <span class="label">口语:</span>
                <span class="text texthide">{{
                  item.spoken | tranSpoken
                }}</span>
              </div>
            </div>
            <div class="fo-item w_one_third">
              <div class="i_info">
                <span class="label">书写:</span>
                <span class="text texthide">{{
                  item.written | tranSpoken
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="info-wrap" v-show="info.academic_data.length > 0">
        <h3 class="title">最高学历</h3>
        <div class="edu-wrap fo-wrap info-cont-wrap">
          <div
            class="fo-list"
            v-for="(item, index) in info.academic_data"
            :key="index"
          >
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label" style="width:110px">起止日期:</span>
                <span class="text texthide"
                  >{{ item.academic_start_date | tranNull }} --
                  {{ item.academic_end_date | tranNull }}</span
                >
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label" style="width:110px">地点:</span>
                <span class="text texthide">{{
                  item.academic_address | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label" style="width:110px">学校:</span>
                <span class="text texthide">{{
                  item.academic_venue | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label" style="width:110px">学历/职称:</span>
                <span class="text texthide">{{
                  item.qualification | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label" style="width:110px">证明人:</span>
                <span class="text texthide">{{
                  item.references_man | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label" style="width:110px">联系方式:</span>
                <span class="text texthide">{{
                  item.contact_details | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label" style="width:150px">是否足球专项专业:</span>
                <span class="text texthide" v-if="item.is_football">是</span>
                <span class="text texthide" v-else>否</span>
              </div>
            </div>
            <div class="fo-item w_half" v-if="item.academic_number">
              <div class="i_info">
                <span class="label" style="width:110px">学历证书编号:</span>
                <span class="text texthide">{{item.academic_number | tranNull}}</span>
              </div>
            </div>
            <div class="fo-item w_all" v-if="item.work_certificate">
              <div class="i_info">
                <span class="label" style="width:110px">学历证书文件:</span>
                <a class="suc" :href="item.work_certificate" target="_blank">{{item.work_certificate_title}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="info-wrap" v-show="info.coach_data.length > 0">
        <h3 class="title">等级教练员证书培训历程</h3>
        <div class="leval-wrap fo-wrap info-cont-wrap">
          <div
            class="fo-list"
            v-for="(item, index) in info.coach_data"
            :key="index"
          >
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label">起止日期:</span>
                <span class="text texthide"
                  >{{ item.train_start_date | tranNull }} --
                  {{ item.train_end_date | tranNull }}</span
                >
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label">地点:</span>
                <span class="text texthide">{{
                  item.train_address | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label">何等级:</span>
                <span class="text texthide">{{
                  item.train_certificate | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label">证书编号:</span>
                <span class="text texthide">{{
                  item.certificate_number | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label">主讲师:</span>
                <span class="text texthide">{{
                  item.train_references | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label">联系方式:</span>
                <span class="text texthide">{{
                  item.train_contact_details | tranNull
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="info-wrap" v-show="info.experience_data.length > 0">
        <h3 class="title">主要执教经历</h3>
        <div class="teach-wrap fo-wrap info-cont-wrap">
          <div
            class="fo-list"
            v-for="(item, index) in info.experience_data"
            :key="index"
          >
            <div class="fo-item w_all">
              <div class="i_info">
                <span class="label">起止日期:</span>
                <span class="text texthide"
                  >{{ item.coach_start_date | tranNull }} --
                  {{ item.coach_end_date | tranNull }}</span
                >
              </div>
            </div>
            <div class="fo-item w_all">
              <div class="i_info">
                <span class="label">单位名称:</span>
                <span class="text texthide">{{
                  item.unit_name | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label">执教球队:</span>
                <span class="text">{{item.coach_team | tranNull}}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label">职务:</span>
                <span class="text texthide">{{
                  item.coach_position | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_all">
              <div class="i_info">
                <span class="label">参赛级别:</span>
                <span class="text texthide">{{
                  item.team_level | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label">证明人:</span>
                <span class="text texthide">{{
                  item.coach_references | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label">证明人职务:</span>
                <span class="text texthide">{{
                  item.references_position | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label">联系方式:</span>
                <span class="text texthide">{{
                  item.coach_contact_details | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_all">
              <div class="i_info">
                <span class="label">地点:</span>
                <span class="text">{{ item.coach_address | tranNull }}</span>
              </div>
            </div>
            <div class="fo-item w_all">
              <div class="i_info">
                <span class="label">主要成绩:</span>
                <span class="text">{{
                  item.coach_achievements | tranNull
                }}</span>
              </div>
            </div>
            <div
              class="fo-item w_all"
              v-if="item.work_certificate && item.work_certificate_title"
            >
              <div class="i_info">
                <span class="label">工作证明:</span>
                <a
                  class="suc"
                  :href="item.work_certificate"
                  target="_blank"
                  :download="item.work_certificate_title"
                  >{{ item.work_certificate_title }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 其他工作经历 -->
      <div class="info-wrap" v-show="info.experience_data_not.length > 0">
        <h3 class="title">其他非执教工作经历</h3>
        <div class="teach-wrap fo-wrap info-cont-wrap">
          <div
            class="fo-list"
            v-for="(item, index) in info.experience_data_not"
            :key="index"
          >
            <div class="fo-item w_all">
              <div class="i_info">
                <span class="label">起止日期:</span>
                <span class="text texthide"
                  >{{ item.coach_start_date | tranNull }} --
                  {{
                    item.coach_end_date | endTimeFilter(item.coach_start_date)
                  }}</span
                >
              </div>
            </div>
            <div class="fo-item w_all">
              <div class="i_info">
                <span class="label">单位名称:</span>
                <span class="text">{{ item.unit_name | tranNull }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label">职务:</span>
                <span class="text texthide">{{
                  item.coach_position | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label">证明人:</span>
                <span class="text texthide">{{
                  item.coach_references | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label">证明人职务:</span>
                <span class="text texthide">{{
                  item.references_position | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label">联系方式:</span>
                <span class="text texthide">{{
                  item.coach_contact_details | tranNull
                }}</span>
              </div>
            </div>
            <!-- <div class="fo-item w_all">
            <div class="i_info">
              <span class="label">执教球队:</span>
              <span class="text">{{item.coach_team | tranNull}}</span>
            </div>
          </div> -->
            <div class="fo-item w_all">
              <div class="i_info">
                <span class="label">地点:</span>
                <span class="text">{{ item.coach_address | tranNull }}</span>
              </div>
            </div>
            <div class="fo-item w_all">
              <div class="i_info">
                <span class="label">主要经历:</span>
                <span class="text">{{
                  item.coach_achievements | tranNull
                }}</span>
              </div>
            </div>
            <div
              class="fo-item w_all"
              v-if="item.work_certificate && item.work_certificate_title"
            >
              <div class="i_info">
                <span class="label">工作证明:</span>
                <a
                  class="suc"
                  :href="item.work_certificate"
                  target="_blank"
                  :download="item.work_certificate_title"
                  >{{ item.work_certificate_title }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="info-wrap" v-show="info.playing_data.length > 0">
        <h3 class="title">主要运动经历</h3>
        <div class="play-wrap fo-wrap info-cont-wrap">
          <div
            class="fo-list"
            v-for="(item, index) in info.playing_data"
            :key="index"
          >
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label">起止日期:</span>
                <span class="text texthide"
                  >{{ item.play_start_date | tranNull }} --
                  {{ item.play_end_date | tranNull }}</span
                >
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label">球队级别:</span>
                <span class="text texthide">{{
                  item.play_team_level | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label">主教练:</span>
                <span class="text texthide">{{
                  item.play_references | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info">
                <span class="label">联系方式:</span>
                <span class="text texthide">{{
                  item.play_contact_details | tranNull
                }}</span>
              </div>
            </div>
            <div class="fo-item w_all">
              <div class="i_info">
                <span class="label">所在球队:</span>
                <span class="text">{{ item.play_team | tranNull }}</span>
              </div>
            </div>
            <div class="fo-item w_all">
              <div class="i_info">
                <span class="label">地点:</span>
                <span class="text">{{ item.play_address | tranNull }}</span>
              </div>
            </div>
            <div class="fo-item w_all">
              <div class="i_info">
                <span class="label">主要成绩:</span>
                <span class="text">{{
                  item.play_achievements | tranNull
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <yioks-loading></yioks-loading>
    </template>
  </div>
</template>

<script>
import identify1 from "@/assets/images/vita/identify1.png";
import identify2 from "@/assets/images/vita/identify2.png";
import avatorImg from "@/assets/images/person.png";
import { country } from "@/assets/js/country";
import { language, languageArr } from "@/assets/js/language";
import { getStuDetailInfo } from "@/api/common/api";
import { NumberTypes } from "@/assets/js/status";
import { experienceFilter ,EnglishAbilityFilter,AuthenticationType} from "@/assets/js/yioksFilters";
import { storageData } from "@/assets/js/storage";
import fiveMixins from '@/minix/fiveMixins';
const spokenObj = {
  good: "流利",
  normal: "一般",
  poor: "基础",
};
const HOSTURL = process.env.VUE_APP_URL;
export default {
  name: "student-info",
  mixins: [fiveMixins],
  props: {
    uid: {
      type: String,
      required: true,
    },
    cid: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      idImg1Err: false,
      idImg2Err: false,
      avatorErr: false,
      userType:storageData.getUserType(),
      identify1,
      identify2,
      avatorImg,
      info: {},
      showData: false,
    };
  },
  filters: {
    experienceFilter,
    EnglishAbilityFilter,
    AuthenticationType,
    tranCountry(v) {
      if (v) {
        if (v === "--") {
          return "--";
        } else {
          return country[String(v)];
        }
      } else return "--";
    },
    getBirthday(id_number) {
      if (!id_number || id_number.length != 18) {
        return "--";
      } else {
        if (id_number === "--") {
          return "--";
        } else {
          return (
            id_number.substr(6, 4) +
            "-" +
            id_number.substr(10, 2) +
            "-" +
            id_number.substr(12, 2)
          );
        }
      }
    },
    tranLang(v) {
      if (v) return language[String(v)];
      else return "--";
    },
    tranNull(v) {
      return v || "--";
    },
    endTimeFilter(v, startTime) {
      if (startTime) {
        return v || "至今";
      } else {
        return v || "--";
      }
    },
    tranSpoken(v) {
      if (v) return spokenObj[v];
      else return "--";
    },
    getNumberType(type) {
      return NumberTypes(type);
    },
  },
  watch: {
    uid: {
      handler(val) {
        this.showData = false;
        this.getDetailInfo();
      },
    },
  },
  components: {
    "yioks-loading": () => import("@/components/Loading/Loading"),
  },
  created() {
    this.getDetailInfo();
  },
  methods: {
    getDetailInfo() {
      getStuDetailInfo({ uuid: this.uid, c_id: this.cid }).then(({ data }) => {
        if (data.status === 0) {
          const { result } = data;
          this.info.studentSingnInfo = {
            ...result.studentSingnInfo,
            id_card_photo_front: result.studentSingnInfo.id_card_photo_front
              ? HOSTURL + result.studentSingnInfo.id_card_photo_front
              : identify1,
            id_card_photo_verso: result.studentSingnInfo.id_card_photo_verso
              ? HOSTURL + result.studentSingnInfo.id_card_photo_verso
              : identify2,
            profile_picture: result.studentSingnInfo.profile_picture
              ? HOSTURL + result.studentSingnInfo.profile_picture
              : avatorImg,
          };
          for (const key in this.studentSingnInfo) {
            if (this.studentSingnInfo.hasOwnProperty(key)) {
              const element = this.studentSingnInfo[key];
              this.studentSingnInfo[key] = element || "--";
            }
          }

          this.info.language_list = [...result.language_list];
          this.info.academic_data = [...result.academic_data];
          this.info.coach_data = [...result.coach_data];
          this.info.experience_data = [...result.experience_data];
          this.info.experience_data_not = [...result.experience_data_not];
          this.info.playing_data = [...result.playing_data];
          if (this.info.studentSingnInfo.student_information === 'Active' && !this.info.studentSingnInfo.total_score && result.experience_data_backup.length > 0 ){
            this.info.experience_data = [...result.experience_data_backup];
          }
          //
          this.showData = true;
        } else {
          this.$message.error(data.msg || "请求失败");
        }
      });
    },
  },
};
</script>


<style lang="stylus" scoped>
@import '~@/assets/css/variable'
@import '~@/assets/css/mixin'
$margin = 5px
.stu-info-root
  display block
  .fo-wrap
    display block
    .fo-list
      display flex
      flex-wrap wrap
      align-items flex-start
      margin-left -($margin)
      margin-right -($margin)
      &:not(:last-child)
        border-bottom 1px dashed #ccc
      &+.fo-list
        margin-top 15px
      .fo-item
        display inline-block
        padding-right $margin
        padding-left $margin
        margin-bottom 6px
        .i_info
          display block
  .label
    float left
    width 90px
    text-align right
    padding-right 5px
    &+.text
      display block
      margin-left 80px
      &.texthide
        over_hide()
  .w_half
    width 50%
  .w_all
    width 100%
  .w_one_third
    width 33.33333333333333%
  .info-wrap
    display block
    &+.info-wrap
      margin-top 15px
    .info-cont-wrap
      padding 0 10px
    .title
      display block
      font-weight bolder
      font-size 18px
      line-height 1
      padding-bottom 8px
      border-bottom 1px solid #ccc
      margin-bottom 10px
    .person-wrap
      .img-list
        display flex
        justify-content space-between
        margin-bottom 15px
        .img
          width 100%
          display block
        .ident
          width 38%
        .passport
          width 20%
.suc
  color $color_suc
</style>

